import './AppOutlets/index';
import './AppOutlets/custom';
import './SdkInit';
import {getOutlet} from 'reconnect.js';
import * as AppActions from './AppActions/index';
import * as CustomActions from './AppActions/custom';

const ActionOutlet = getOutlet('actions');

ActionOutlet.update({
  ...AppActions,
  ...CustomActions,
});

if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
}

// workaround for CSP require-trusted-types-for 'script'
if (
  typeof window !== 'undefined' &&
  window.trustedTypes &&
  window.trustedTypes.createPolicy
) {
  window.trustedTypes.createPolicy('default', {
    createHTML: (string) => string,
    createScriptURL: (string) => string,
    createScript: (string) => string,
  });
}

console.log('App initialized');
